export default "__VITE_ASSET__yDUW9Rhm__"